<template>
  <div class="choose-block">
    <div class="container">
      <h3>Choose Your Path</h3>
      <h2>The Quest Begins</h2>
      <p>TRUE WORLD is an ever-expanding universe of adventures. Choose your next destination:</p>
      <div class="cards">
        <div class="card">
          <div class="badge">TOP</div>
          <strong>Play TRUE Games at&nbsp;Our&nbsp;Partners</strong>
          <div class="image">
            <img src="./images/CYP-image-1.png">
          </div>
          <div class="line">
            Trusted by 500+ Casinos Worldwide
          </div>
          <div class="buttons">
            <router-link :to="{ name: 'world', hash: '#true-games'}">All games</router-link>
          </div>
        </div>
        <div class="card">
          <strong>Earn Rewards in&nbsp;Telegram&nbsp;App</strong>
          <div class="image">
            <img src="./images/CYP-image-2.png">
          </div>
          <div class="line">
            Play for Free
          </div>
          <div class="buttons">
            <a href="https://t.me/true_coin_bot/app" target="_blank">Open App</a>
          </div>
        </div>
        <div class="card">
          <strong>Unlock Exclusive<br> Assets</strong>
          <div class="image">
            <img src="./images/CYP-image-3.png">
          </div>
          <div class="line">
            Buy, Sell, Trade
          </div>
          <div class="buttons">
            <router-link :to="{ name: 'market' }">
              {{ $i18n.get(`Marketplace`) }}
            </router-link>
          </div>
        </div>
      </div>

      <div class="upcoming">
        <div class="block-title">
          <div class="title">Upcoming Games</div>
          <a href="https://t.me/trueworld" target="_blank" class="right"><img src="./images/notify-icon.svg"> <span>Stay updated on Telegram</span></a>
        </div>
        <div class="games">
          <div v-for="game in games">
            <div class="title">
              <div class="image"><img :src="gamesImages[game.title]"></div>
              <div class="name">{{ game.title }}</div>
            </div>
            <div class="dot"><span></span></div>
            <div class="date">
              <span>{{ $moment.unix(game.propertyReleaseDate).format("MMM YYYY") }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'choose-block',
  props: {
    gamesImages: {},
  },
  data() {
    return {
      games: [],
    }
  },
  methods: {
    getPopularGames: async function() {
      await this.$request.get('/true-world/upcoming-games', null, response => {
        this.games = response
        this.games = this.games.slice(0,4);
      }, error => {
        console.log(error)
      })
    },
    imageUrlAlt: (event) => {
      event.target.src = require("./images/no-image.png");
    }
  },
  async mounted() {
    await this.getPopularGames();
  }
}
</script>

<style lang="less" scoped>
  .choose-block {
    padding-top: 140px;
    padding-bottom: 167px;
    background-image: url("./images/Top-Shape-Image.png");
    background-position: top center;
    background-size: 2560px;
    background-repeat: no-repeat;

    > .container {
      > h3 {
        font-family: 'Poppins';
        font-style: normal;
        font-weight: 500;
        font-size: 30px;
        line-height: 45px;
        text-align: center;
        margin-bottom: 2px;
        background: linear-gradient(90.62deg, #DF60FF 0%, #9C94FF 49.03%, #44E9C3 62.94%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        text-fill-color: transparent;
      }
      > h2 {
        color: #FFF;
        font-family: Poppins;
        font-weight: 700;
        font-size: 50px;
        line-height: 64px;
        text-align: center;
        margin-bottom: 16px;
      }
      > p {
        color: #FFFFFF99;
        font-family: Poppins;
        font-weight: 500;
        font-size: 24px;
        line-height: 38px;
        text-align: center;
        margin-bottom: 50px;
        padding: 0 230px;
      }
      > .cards {
        display: flex;
        gap: 20px;
        margin-bottom: 40px;
        > .card {
          position: relative;
          width: 380px;
          background: #C9D8FF1A;
          border-radius: 40px;
          padding: 36px 0px 36px 0px;
          > .badge {
            position: absolute;
            top: 0;
            right: 0;
            display: flex;
            width: 60px;
            height: 32px;
            justify-content: center;
            align-items: center;
            font-family: Poppins;
            font-weight: 700;
            font-size: 16px;
            line-height: 100%;
            text-align: center;
            background: linear-gradient(90deg, #FF8C4B 0%, #F33E69 100%);
            color: #FFF;
            border-radius: 16px 16px 16px 0;
          }
          > strong {
            padding: 0 40px;
            display: block;
            color: #FFF;
            font-family: Poppins;
            font-weight: 700;
            font-size: 20px;
            line-height: 28px;
            margin-bottom: 6px;
          }
          > .image {
            margin-bottom: 24px;
            > img {
              display: block;
              width: 100%;
            }
          }
          > .line {
            /* bg */
            padding: 15px 0;
            transform: rotate(-1deg);
            background: linear-gradient(90.67deg, #DF60FF -30.99%, #9C94FF 58.94%, #44E9C3 104.68%), #D9D9D9;
            font-family: Poppins;
            font-weight: 700;
            font-size: 16px;
            line-height: 100%;
            text-align: center;
            margin-bottom: 22px;
          }
          > .buttons {
            padding: 0 40px;
            > a {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 100%;
              height: 60px;
              border-radius: 14px;
              transition: all .2s;
              color: #fff;
              font-size: 16px;
              line-height: 24px;
              border: 1px solid #FFFFFF33;
              &:hover {
                border-color: #fff;
              }
            }
          }
        }
      }
      > .upcoming {
        padding: 24px 30px;
        margin-bottom: 25px;
        overflow: hidden;

        > .block-title {
          position: relative;
          > .title {
            font-family: Poppins;
            font-weight: 700;
            font-size: 24px;
            line-height: 38px;
            text-align: center;
            color: #FFF;
            margin-bottom: 28px;
          }
          > a {
            position: absolute;
            top: 10px;
            right: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 8px;
            font-family: Poppins;
            font-weight: 600;
            font-size: 14px;
            line-height: 100%;
            color: #7252FF;
            > span {
              padding-bottom: 2px;
              border-bottom: 1px solid #7252FF99;
            }
          }
        }

        > .games {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          padding: 0 60px 0 80px;
          gap: 4px;
          background-image: url("./images/Arrow.svg");
          background-position: bottom 30px center;
          background-repeat: no-repeat;
          background-size: 100%;

          > div {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            overflow: visible;
            position: relative;
            gap: 8px;
            border-radius: 14px;

            > .title {
              display: flex;
              gap: 10px;
              margin-bottom: 13px;
              padding-left: 29px;
              > .image {
                display: flex;
                align-items: center;
                > img {
                  border-radius: 100px;
                  width: 60px;
                  height: 60px;
                }
              }
              > .name {
                display: flex;
                align-items: center;
                flex: 1;
                color: #fff;
                font-size: 14px;
              }
            }

            > .dot {
              bottom: 45px;
              left: 13px;
              position: absolute;
              display: flex;
              align-items: flex-start;
              width: 27px;
              overflow: visible;
              > span {
                position: absolute;
                left: 38px;
                top: 0;
                width: 16px;
                height: 16px;
                background: #010209;
                border-radius: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                border: 2px solid #67676B;
                z-index: 3;

                &:before {
                  content: '';
                  position: relative;
                  display: flex;
                  width: 8px;
                  height: 8px;
                  background: #67676B;
                  border-radius: 100%;
                }
              }
            }
            > .date {
              width: 85px;
              margin-left: 29px;
              margin-top: 20px;
              display: flex;
              align-items: center;
              gap: 8px;
              padding-right: 16px;
              > span {
                color: #FFFFFF99;
                font-family: Poppins;
                font-weight: 500;
                font-size: 14px;
                line-height: 100%;
                text-align: center;
              }
            }
            &:last-child {
              > .dot:before {
                display: none;
              }
            }
          }
        }

        > a {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 14px;
          border: 1px solid #FFFFFF33;
          border-radius: 12px;
          height: 50px;
          color: #fff;
          font-size: 13px;
          &:hover {
            border-color: #fff;
          }
        }
      }
    }
  }

  @media screen and (max-width: 1439px) {
    .choose-block {
      padding-top: 90px;
      padding-bottom: 125px;
      background-size: 1920px;

      > .container {
        > h3 {
          font-size: 24px;
          line-height: 100%;
          margin-bottom: 0;
        }
        > h2 {
          font-size: 46px;
          line-height: 50px;
          margin-bottom: 12px;
        }
        > p {
          font-size: 18px;
          line-height: 28px;
          margin-bottom: 39px;
          padding: 0 140px;
        }
        > .cards {
          display: flex;
          gap: 12px;
          margin-bottom: 40px;
          > .card {
            width: 274px;
            border-radius: 30px;
            padding: 29px 0px 30px 0px;

            > .badge {
              width: 50px;
              height: 24px;
              font-size: 13px;
              line-height: 100%;
              border-radius: 16px 16px 16px 0;
            }
            > strong {
              padding: 0 30px;
              font-size: 20px;
              line-height: 26px;
              margin-bottom: 1px;
            }
            > .image {
              margin-bottom: 6px;
              > img {
                display: block;
                width: 100%;
              }
            }
            > .line {
              /* bg */
              padding: 10px 0;;
              font-size: 13px;
              line-height: 100%;
              margin-bottom: 17px;
            }
            > .buttons {
              padding: 0 30px;
              > a {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: 60px;
                border-radius: 14px;
                transition: all .2s;
                color: #fff;
                font-size: 16px;
                line-height: 24px;
                border: 1px solid #FFFFFF33;
                &:hover {
                  border-color: #fff;
                }
              }
            }
          }
        }
        > .upcoming {
          padding: 24px 30px;
          margin-bottom: 25px;
          overflow: hidden;

          > .block-title {
            position: relative;
            > .title {
              font-family: Poppins;
              font-weight: 700;
              font-size: 20px;
              line-height: 100%;
              text-align: center;
              color: #FFF;
              margin-bottom: 28px;
            }
            > a {
              position: absolute;
              top: 2px;
              right: 0;
              display: flex;
              justify-content: center;
              align-items: center;
              gap: 8px;
              font-family: Poppins;
              font-weight: 600;
              font-size: 14px;
              line-height: 100%;
              color: #7252FF;
              > span {
                padding-bottom: 2px;
                border-bottom: 1px solid #7252FF99;
              }
            }
          }

          > .games {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            padding: 0 60px 0 80px;
            gap: 4px;
            background-image: url("./images/Arrow.svg");
            background-position: bottom 30px center;
            background-repeat: no-repeat;
            background-size: 100%;

            > div {
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              overflow: visible;
              position: relative;
              gap: 8px;
              border-radius: 14px;

              > .title {
                display: flex;
                gap: 10px;
                margin-bottom: 13px;
                padding-left: 29px;
                > .image {
                  display: flex;
                  align-items: center;
                  > img {
                    border-radius: 100px;
                    width: 60px;
                    height: 60px;
                  }
                }
                > .name {
                  display: flex;
                  align-items: center;
                  flex: 1;
                  color: #fff;
                  font-size: 14px;
                }
              }

              > .dot {
                bottom: 45px;
                left: 13px;
                position: absolute;
                display: flex;
                align-items: flex-start;
                width: 27px;
                overflow: visible;
                > span {
                  position: absolute;
                  left: 38px;
                  top: 0;
                  width: 16px;
                  height: 16px;
                  background: #010209;
                  border-radius: 100%;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  border: 2px solid #67676B;
                  z-index: 3;

                  &:before {
                    content: '';
                    position: relative;
                    display: flex;
                    width: 8px;
                    height: 8px;
                    background: #67676B;
                    border-radius: 100%;
                  }
                }
              }
              > .date {
                width: 85px;
                margin-left: 29px;
                margin-top: 20px;
                display: flex;
                align-items: center;
                gap: 8px;
                padding-right: 16px;
                > span {
                  color: #FFFFFF99;
                  font-family: Poppins;
                  font-weight: 500;
                  font-size: 14px;
                  line-height: 100%;
                  text-align: center;
                }
              }
              &:last-child {
                > .dot:before {
                  display: none;
                }
              }
            }
          }

          > a {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 14px;
            border: 1px solid #FFFFFF33;
            border-radius: 12px;
            height: 50px;
            color: #fff;
            font-size: 13px;
            &:hover {
              border-color: #fff;
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: 1023px) {
    .choose-block {
      padding-top: 70px;
      padding-bottom: 94px;
      background-size: 1920px;

      > .container {
        > h3 {
          font-size: 20px;
          line-height: 100%;
          margin-bottom: 0;
        }
        > h2 {
          font-size: 36px;
          line-height: 40px;
          margin-bottom: 10px;
        }
        > p {
          font-size: 16px;
          line-height: 26px;
          margin-bottom: 30px;
          padding: 0 99px;
        }
        > .cards {
          display: flex;
          gap: 12px;
          margin-bottom: 40px;
          > .card {
            width: 212px;
            border-radius: 20px;
            padding: 19px 0px 20px 0px;

            > .badge {
              width: 42px;
              height: 21px;
              font-size: 11px;
              line-height: 100%;
              border-radius: 12px 12px 12px 0;
            }
            > strong {
              padding: 0 20px;
              font-size: 16px;
              line-height: 22px;
              margin-bottom: 9px;
            }
            > .image {
              margin-bottom: 15px;
              > img {
                display: block;
                width: 100%;
              }
            }
            > .line {
              display: flex;
              justify-content: center;
              align-items: center;
              height: 44px;
              padding: 6px 0;;
              font-size: 12px;
              line-height: 16px;
              margin-bottom: 15px;
            }
            > .buttons {
              padding: 0 20px;
              > a {
                width: 100%;
                height: 40px;
                border-radius: 12px;
                font-size: 13px;
                line-height: 20px;
              }
            }
          }
        }
        > .upcoming {
          padding: 24px 0px;
          margin-bottom: 25px;

          > .block-title {
            > .title {
              font-size: 18px;
              line-height: 100%;
              margin-bottom: 30px;
            }
            > a {
              position: absolute;
              top: 2px;
              right: 0;
              display: flex;
              justify-content: center;
              align-items: center;
              gap: 8px;
              font-family: Poppins;
              font-weight: 600;
              font-size: 13px;
              line-height: 100%;
              color: #7252FF;
              > span {
                padding-bottom: 2px;
                border-bottom: 1px solid #7252FF99;
              }
            }
          }

          > .games {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            padding: 0 60px 0 80px;
            gap: 4px;
            background-image: url("./images/Arrow.svg");
            background-position: bottom 30px center;
            background-repeat: no-repeat;
            background-size: 100%;

            > div {
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              overflow: visible;
              position: relative;
              gap: 8px;
              border-radius: 14px;

              > .title {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                gap: 10px;
                margin-bottom: 13px;
                padding-left: 20px;
                > .image {
                  display: flex;
                  align-items: center;
                  > img {
                    border-radius: 100px;
                    width: 60px;
                    height: 60px;
                  }
                }
                > .name {
                  display: flex;
                  align-items: center;
                  flex: 1;
                  color: #fff;
                  font-size: 14px;
                }
              }

              > .dot {
                bottom: 45px;
                left: 13px;
                position: absolute;
                display: flex;
                align-items: flex-start;
                width: 27px;
                overflow: visible;
                > span {
                  position: absolute;
                  left: 38px;
                  top: 0;
                  width: 16px;
                  height: 16px;
                  background: #010209;
                  border-radius: 100%;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  border: 2px solid #67676B;
                  z-index: 3;

                  &:before {
                    content: '';
                    position: relative;
                    display: flex;
                    width: 8px;
                    height: 8px;
                    background: #67676B;
                    border-radius: 100%;
                  }
                }
              }
              > .date {
                width: 85px;
                margin-left: 29px;
                margin-top: 20px;
                display: flex;
                align-items: center;
                gap: 8px;
                padding-right: 16px;
                > span {
                  color: #FFFFFF99;
                  font-family: Poppins;
                  font-weight: 500;
                  font-size: 14px;
                  line-height: 100%;
                  text-align: center;
                }
              }
              &:last-child {
                > .dot:before {
                  display: none;
                }
              }
            }
          }

          > a {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 14px;
            border: 1px solid #FFFFFF33;
            border-radius: 12px;
            height: 50px;
            color: #fff;
            font-size: 13px;
            &:hover {
              border-color: #fff;
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: 767px) {
    .choose-block {
      padding-top: 60px;
      padding-bottom: 46px;
      background-size: 1920px;

      > .container {
        > h3 {
          font-size: 14px;
          line-height: 100%;
          margin-bottom: 0;
        }
        > h2 {
          font-size: 22px;
          line-height: 26px;
          margin-bottom: 6px;
        }
        > p {
          font-size: 13px;
          line-height: 22px;
          margin-bottom: 20px;
          padding: 0 15px;
        }
        > .cards {
          display: flex;
          gap: 12px;
          margin-bottom: 40px;
          width: calc(100% + 15px);
          overflow-x: scroll;
          > .card {
            min-width: 212px;
            width: 212px;
            border-radius: 20px;
            padding: 19px 0px 20px 0px;

            &:nth-child(3) { margin-right: 15px; }

            > .badge {
              width: 42px;
              height: 21px;
              font-size: 11px;
              line-height: 100%;
              border-radius: 12px 12px 12px 0;
            }
            > strong {
              padding: 0 20px;
              font-size: 16px;
              line-height: 22px;
              margin-bottom: 9px;
            }
            > .image {
              margin-bottom: 15px;
              > img {
                display: block;
                width: 100%;
              }
            }
            > .line {
              display: flex;
              justify-content: center;
              align-items: center;
              height: 44px;
              padding: 6px 0;;
              font-size: 12px;
              line-height: 16px;
              margin-bottom: 15px;
            }
            > .buttons {
              padding: 0 20px;
              > a {
                width: 100%;
                height: 40px;
                border-radius: 12px;
                font-size: 13px;
                line-height: 20px;
              }
            }
          }
        }
        > .upcoming {
          position: relative;
          padding: 24px 0px;
          margin-bottom: 25px;

          > .block-title {
            position: static;
            > .title {
              font-size: 18px;
              line-height: 100%;
              margin-bottom: 30px;
            }
            > a {
              position: absolute;
              top: auto;
              bottom: 0;
              right: auto;
              width: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              gap: 8px;
              font-family: Poppins;
              font-weight: 600;
              font-size: 11px;
              line-height: 100%;
              color: #7252FF;
              > span {
                padding-bottom: 2px;
                border-bottom: 1px solid #7252FF99;
              }
            }
          }

          > .games {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            padding: 0;
            gap: 4px;
            background: none;
            padding-bottom: 16px;

            > div {
              display: flex;
              flex-direction: row;
              align-items: center;
              height: 50px;
              overflow: visible;
              position: relative;
              gap: 8px;
              border-radius: 14px;
              background: linear-gradient(270deg, rgba(201, 216, 255, 0.06) 0%, rgba(201, 216, 255, 0) 100%);


              > .title {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;
                gap: 10px;
                margin-bottom: 0;
                padding-left: 28px;
                flex: 1;
                > .image {
                  display: flex;
                  align-items: center;
                  > img {
                    border-radius: 100px;
                    width: 36px;
                    height: 36px;
                  }
                }
                > .name {
                  display: flex;
                  align-items: center;
                  flex: 1;
                  color: #fff;
                  font-size: 11px;
                }
              }

              > .dot {
                top: 0px;
                bottom: auto;
                left: 0px;
                position: absolute;
                display: flex;
                align-items: flex-start;
                width: 27px;
                overflow: visible;

                &:before {
                  content: '';
                  display: block;
                  position: absolute;
                  left: 0px;
                  top: 36px;
                  background: url("./images/upcoming-dots.png") repeat-y center top;
                  //background-size: 6px;
                  width: 16px;
                  height: 32px;
                  z-index: 2;
                }
                > span {
                  position: absolute;
                  left: 0;
                  top: 17px;
                  width: 16px;
                  height: 16px;
                  background: #010209;
                  border-radius: 100%;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  border: 2px solid #FFFFFF33;
                  z-index: 3;

                  &:before {
                    content: '';
                    position: relative;
                    display: flex;
                    width: 6px;
                    height: 6px;
                    background: #FFFFFF33;
                    border-radius: 100%;
                  }
                }
              }
              > .date {
                width: 85px;
                margin-left: 0;
                margin-top: 0;
                display: flex;
                justify-content: flex-end;
                align-items: center;
                gap: 8px;
                padding-right: 15px;
                > span {
                  color: #FFFFFF99;
                  font-family: Poppins;
                  font-weight: 400;
                  font-size: 11px;
                  line-height: 13px;
                  text-align: center;
                }
              }
              &:last-child {
                > .dot:before {
                  display: none;
                }
              }
            }
          }

          > a {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 14px;
            border: 1px solid #FFFFFF33;
            border-radius: 12px;
            height: 50px;
            color: #fff;
            font-size: 13px;
            &:hover {
              border-color: #fff;
            }
          }
        }
      }
    }
  }
</style>
